import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { AxiosResponse } from 'axios';
import { useMemo } from 'react';
import { Cohort } from 'TenantModule/api/getCohortsApi';
import { getAllCohortsApi } from 'TenantModule/api/cohortAdminApi';
import { cohortQueryKeys } from './cohortQueryKeys';

/**
 * Admin list (GET /cohort): every cohort including the dedicated cohorts-of-one
 * that back Single/Shared tenants — distinct from the picker query, which returns
 * only ACTIVE multi-seat Enterprise cohorts.
 */
export const useAllCohortsQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const query = useAppQuery<AxiosResponse<Cohort[]>>({
    queryKey: cohortQueryKeys.list({ identifier: 'useAllCohortsQuery' }),
    queryFn: ({ token, buildConfig }) =>
      getAllCohortsApi({ params: undefined, token, config: buildConfig() }),
    staleTime: 30 * 1000,
    enabled,
  });

  const cohorts: Cohort[] = useMemo(() => {
    const raw = query.data?.data;
    return Array.isArray(raw) ? raw : [];
  }, [query.data?.data]);

  return { cohorts, isLoading: query.isLoading, isError: query.isError };
};
